import {NetworkService} from "./NetworkService";
import Swal from 'sweetalert2';
import {NetworkRequest} from "./NetworkRequest";
import {attributeClear} from "../store/attributeStore";

class DimensionamentoServices {

  async getReportComplexity(seletedCity){
    try {
      if(!seletedCity) return

      return await NetworkService.request({
        url: "reports/complexity",
        method: 'GET',
        params: {
          city: seletedCity.city,
          state: seletedCity.state
        }
      }).then((res) => {
        return res;
      });
    } catch (error) {
      console.error('Erro ao buscar os dados:', error);
      Swal.fire({
        icon: 'error',
        title: 'Erro',
        text: "Houve um problema ao buscar os dados, contate um administrador.",
        confirmButtonText: 'Ok'
      }).then((result) => {
        if (result.isConfirmed) window.location.reload();
      });
    }
  }

  async getSearchType(city){
    try{
      if (!city) return null
      return await NetworkService.request({
        url: "dimensionamento/search_type",
        method: "GET",
        params:{
          city: city,
        }
      }).then((res) => {
        return res
      })
    } catch (error){
      console.error('Erro ao buscar dados: ', error)
    }
  }

  async getSearchTypeWithUF(city){
    try{
      if (!city) return null
      return await NetworkService.request({
        url: "dimensionamento/search_type_uf",
        method: "GET",
        params:{
          city: city
        }
      }).then((res) => {
        return res
      })
    } catch (error){
      console.error('Erro ao buscar dados: ', error)
    }
  }

  async getRegions(regionType, UF){
    try{
      if (!regionType || regionType === "NOME DO MUNICÍPIO") return null
      return await NetworkService.request({
        url: "dimensionamento/region",
        method: "GET",
        params: {
          regionType: regionType,
          UF: UF
        }
      }).then ((res) => {
        return res
      })
    } catch (error){
      console.error('Erro ao buscar dados', error)
    }
  }

  async fetchCities(){
    return NetworkService.request({
      url: "dimensionamento/cities",
      method: 'GET'
    });
  }
  
  async uploadFileBeneficiarios(file) {
    const formData = new FormData();
    formData.append('file', file);
    try {
      return await NetworkService.request({
        alias: NetworkRequest.UploadFileBeneficiarios,
        url: "dimensionamento/upload/beneficiarios",
        method: "POST",
        data: formData,
        contentType: "multipart/form-data"
      });
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  async uploadFileDataCollect(step, file) {
    const formData = new FormData();
    formData.append('file', file);
    try {
      return await NetworkService.request({
        alias: NetworkRequest.UploadFileBeneficiarios,
        url: "dimensionamento/upload/specialties-data",
        params: {
          step: step
        },
        method: "POST",
        data: formData,
        contentType: "multipart/form-data"
      });
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  postBeneficiarios(beneficiarios) {
    return NetworkService.request({
      alias: NetworkRequest.PostBeneficiarios,
      url: "dimensionamento/beneficiarios",
      method: "POST",
      data: beneficiarios
    }).then(() => {
        attributeClear();
        Swal.fire({
          icon: "success",
          title: "Operação concluída",
          text: "Os dados foram registrados com sucesso!",
          showConfirmButton: true,
          confirmButtonText: "Finalizar",
          confirmButtonColor: "#2F855A",
          timer: 3000,
          timerProgressBar: true,
          allowOutsideClick: false,
        }).then(() => {
          setTimeout(() => {
            window.location.reload();
          }, 500);
        });
      })
      .catch(reason => {
        console.error(reason)
        Swal.fire({
          icon: 'error',
          title: 'Erro',
          text: "Houve um problema em registar os beneficiarios, tente novamente mais tarde",
          confirmButtonText: 'Ok'
        }).then((result) => {
          if (result.isConfirmed) window.location.reload();
        })
      })
  }

  getBeneficiariosDemografico() {
    return NetworkService.request({
      alias: NetworkRequest.FetchDemographicData,
      url: "reports/beneficiary-demographic-data",
      method: "GET",
    }).catch(reason => {
      console.error(reason)
    })
  }

  getNeedsByServiceTypeReport(city, state) {
    return NetworkService.request({
      alias: NetworkRequest.FetchNeedsByServiceType,
      url: `reports/needs-by-service-type`,
      method: "GET",
      params: {
        city: city,
        state: state
      }
    }).catch(reason => {
      console.error(reason)
      Swal.fire({
        icon: 'error',
        title: 'Erro',
        text: "Houve um problema ao buscar os dados, contate um administrador.",
        confirmButtonText: 'Ok'
      }).then((result) => {
        if (result.isConfirmed) window.location.reload();
      })
    })
  }

  hasAnyCauseAndActionReport() {
    return NetworkService.request({
      alias: NetworkRequest.FetchHasAnyCauseAndActionReport,
      url: `reports/cause-and-action/has-any`,
      method: "GET"
    }).catch(reason => {
      console.error(reason)
    })
  }

  getCitiesWithCauseAndActionReport() {
    return NetworkService.request({
      alias: NetworkRequest.FetchCitiesWithCauseAndActionReport,
      url: `reports/cause-and-action/cities`,
      method: "GET"
    }).catch(reason => {
      console.error(reason)
    })
  }

  getCauseAndActionReport(city, state) {
    return NetworkService.request({
      alias: NetworkRequest.FetchCauseAndAction,
      url: `reports/cause-and-action`,
      method: "GET",
      params: {
        city: city,
        state: state
      }
    }).catch(reason => {
      console.error(reason)
    })
  }

  postCauseAndActionReport(data) {
    return NetworkService.request({
      alias: NetworkRequest.PostCauseAndAction,
      url: `reports/cause-and-action`,
      method: "POST",
      data: data
    }).then(() => {
      Swal.fire({
        position: "center",
        icon: "success",
        title: "Dados salvos com sucesso!",
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true
      }).then((result) => {
        if (result.isConfirmed) window.location.reload();
      })
    })
      .catch(reason => {
        console.error(reason)
        Swal.fire({
          icon: 'error',
          title: 'Erro',
          text: "Houve um problema em registar os dados",
          confirmButtonText: 'Ok'
        }).then((result) => {
          console.log(result)
        })
      })
  }

  updateCauseAndActionReport(data, city, state) {
    return NetworkService.request({
      alias: NetworkRequest.UpdateCauseAndAction,
      url: `reports/cause-and-action/edit`,
      method: "POST",
      params: {
        city: city,
        state: state
      },
      data: data
    }).catch(reason => {
      console.error(reason)
      Swal.fire({
        icon: 'error',
        title: 'Erro',
        text: "Houve um problema em atualizar os dados",
        confirmButtonText: 'Ok'
      }).then((result) => {
        console.log(result)
      })
    })
  }

  async getEstimates(){
    return NetworkService.request({
        url: "reports/estimates",
        method: "GET",
    }).catch(reason => {
      console.error(reason)
    })
  }

  async getNetworkUsageReport() {
    return NetworkService.request({
      url: "reports/network-usage",
      method: "GET"
    }).catch(reason => {
      console.error(reason)
    });

  }

  async getAssistenceGaps(){
    return NetworkService.request({
      url: "reports/assistence-gaps",
      method: "GET"
    }).catch(reason => {
      console.error(reason)
    });
  }

  async getAttributeMapData(state, reportId) {
    return NetworkService.request({
      url: "reports/complexity/state",
      method: "GET",
      params: {
        state: state,
        reportId: reportId
      }
    }).catch(reason => {
      console.error(reason)
    });
  }

  async getCollaborators(steps, state) {
    return NetworkService.request({
      url: "reports/detailed-step-data",
      method: "GET",
      params: {
        steps: steps,
        state: state
      }
    }).catch(reason => {
      console.error(reason)
    });
  }
}
export const DimensionamentoService = new DimensionamentoServices();